import React, {useState} from "react";
import "./App.css";
import Todo3 from "./Todo3";
import Header from "./Header";

function App() {
  //   const [temp, settemp] = useState(" ");

  //   fetch(
  //     "http://api.openweathermap.org/data/2.5/weather?q=raipur,In&APPID=176583b30bb7e52c2e890d0d3874aa51"
  //   )
  //     .then((response) => response.json())
  //     .then((data) => settemp(data.main.temp));

  return (
    <>
      <Header />
      <Todo3 />
    </>
  );
  //   <div className='App'>{temp - 273} Celsius</div>;
}

export default App;
